import axios from 'axios';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import { getToken } from './jwt.service';
import { API_URL } from './config';
import state from '../store';

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
    // eslint-disable-next-line
  Vue.axios.interceptors.response.use(null, function (error) {
      if (error.response.status === 401) {
        state.dispatch('logout');
      }
      return Promise.reject(error);
    });
  },

  setHeader() {
    Vue.axios.defaults.headers.common.Authorization = `Bearer ${getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch((error) => {
      throw error;
    });
  },

  get(resource, slug = '') {
    return Vue.axios.get(`${resource}/${slug}`).catch((error) => {
      throw error;
    });
  },
  blob(resource) {
    return Vue.axios.get(resource, { responseType: 'blob' }).catch((error) => {
      throw error;
    });
  },
  queryBlob(resource) {
    return Vue.axios.get(resource, { responseType: 'arraybuffer' }).catch((error) => {
      throw error;
    });
  },

  post(resource, params, config) {
    return Vue.axios.post(`${resource}`, params, config);
  },

  upload(resource, params) {
    return Vue.axios.post(`${resource}`, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch((error) => {
      throw error;
    });
  },
};

export default ApiService;
